<script setup lang="ts">

import { ref } from "vue";
import { GpsLocation } from "@app/Components/GpsLocation";
import { useViewModelInstance } from "@app/MyGarage";
import { useOfferService } from "@app/MyMarketplace/Services/OfferService";
import { resetRequestedMarketplaceCategory } from "@app/MyMarketplace/Types/useRequestMarketplaceCategory";

const viewModel = await useViewModelInstance();
const rsaOffer = ref( null );

// If we came here from the marketplace, remove any requested category from local storage
resetRequestedMarketplaceCategory();

// Consumer does NOT have RSA, but RSA is available in the app settings
if( viewModel.carePlan.roadsideAssistance.isEnabled == false
    && viewModel.carePlan.roadsideAssistance.isEnabledInAppSettings )
{
    const offerService = useOfferService();
    //rsaOffer.value = offerService.get
}

</script>

<template>

    <div class="tracking-wider dark:bg-gray-900
                w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="pb-4 lg:pb-6 3xl:pb-8
                    bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900">
        
            <h1 class="text-center text-lg 3xl:text-2xl">
                Your Location
            </h1>

            <div class="p-4 lg:p-6 3xl:p-8">
                <GpsLocation />
            </div>

            <div v-if="viewModel.carePlan.roadsideAssistance.isEnabled"
                 class="px-4 lg:px-6 3xl:px-8">

                <h1 class="lg:text-lg 3xl:text-xl">You have Roadside Assistance cover</h1>

                <p class="opacity-60 mb-4 3xl:text-lg 3xl:mb-6">
                    Your Care Plan includes roadside assistance.  If you need roadside 
                    assistance now, call the concierge using the button below
                </p>

                <RoadsideAssistanceButton /> 
            
            </div>
                  
            <div v-else-if="rsaOffer != null">
                RSA OFFER
            </div>
            
        </div>

    </div>   
    
</template>
